import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withTranslation } from 'react-i18next';

import { Notification } from '@mssgme/ui';
import { NOTIFICATIONS_DELAY } from '@mssgme/constants';

// TODO: rewrite into hook
/**
 * @param WrappedComponent
 * @param def
 * @param errorMapper
 * @param paths
 * @deprecated
 */
export const withApi = (
    WrappedComponent,
    def,
    errorMapper = () => undefined,
    paths = ['json.message', 'json.error.message', 'json.errors.message', 'json.type', 'message']
) => {
    return withTranslation()(
        class ApiRequestHandler extends React.Component {
            static propTypes = {
                t: PropTypes.func.isRequired,
                closeDelay: PropTypes.number,
            };

            static defaultProps = {
                closeDelay: NOTIFICATIONS_DELAY,
            };

            state = {
                isFetching: false,
                errors: {},
            };

            request = async (promise) => {
                this.setState({ isFetching: true });

                // todo: fixit or migrate to hooks
                // eslint-disable-next-line no-async-promise-executor
                return new Promise(async (resolve, reject) => {
                    try {
                        const result = await promise;

                        this.setState({ errors: {} }, () => {
                            resolve(result);
                        });
                    } catch (e) {
                        this.setState({ errors: this.handleError(e) }, () => {
                            reject(this.state.errors);
                        });
                    } finally {
                        this.setState({ isFetching: false });
                    }
                });
            };

            handleError(e) {
                switch (e.type) {
                    case 'validation':
                        return this.remapErrors(e.errors);

                    // case 'api':
                    default: {
                        const message = this.parseError(e);

                        Notification.danger(this.props.t(message) || message, { showClose: true });

                        return { message };
                    }
                }
            }

            parseError(error) {
                let message;

                for (const path of paths) {
                    if ((message = get(error, path))) {
                        break;
                    }
                }

                if (message) {
                    return errorMapper(message) || def;
                }

                return def;
            }

            remapErrors(errors) {
                const result = {};

                for (const [key, value] of Object.entries(errors)) {
                    const mapped = errorMapper(value);

                    if (mapped) {
                        result[key] = mapped;
                    } else if (def || value) {
                        result[key] = def || value;
                    }
                }

                return result;
            }

            render() {
                return <WrappedComponent {...this.state} {...this.props} request={this.request} />;
            }
        }
    );
};
